export const AIR_HOTEL = 'AIR_HOTEL';
export const CORE = 'CORE';
export const DLV = 'DLV';

// Error Message
export const INVALID_DEST_ERROR_MSG =
  'Please enter a valid # City or Airport code.';
export const INVALID_DEST_PACKAGE_ERROR_MSG =
  'Vacation Packages are not available to the city entered. Please check the spelling or select the appropriate # city or airport code.';
export const INVALID_ORIGIN_ERROR_MSG =
  '# is an invalid city code. Please check the spelling of # or select another city or airport code from the drop down list.';
